<template>
  <el-dialog :title="`${modalTitle}文案包`" :visible.sync="visible" width="680px" append-to-body :close-on-click-modal="false">
    <el-form
      class="title-add-form"
      :model="formItem"
      :rules="rules"
      label-width="100px"
      ref="titleForm"
      inline
      @submit.native.prevent="() => {}"
    >
      <el-form-item prop="packName" label="文案包名称：">
        <el-input v-model="formItem.packName" clearable style="width: 220px" placeholder="最大30个字符，1个中文等于2个字符"></el-input>
      </el-form-item>

      <el-form-item label="媒体：">
        <el-select
          v-model="formItem.mediaIds"
          placeholder="请选择媒体"
          style="width: 200px"
          multiple
          collapse-tags
          @change="handleMediaChange"
        >
          <el-option v-for="media in medias" :key="media.value" :value="media.value" :label="media.label"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="textarea-wrapper">
      <div class="mark-rows">
        <div class="line-mark" v-for="num in lines" :key="num">{{ num }}</div>
      </div>
      <div v-show="showEmoji" class="emoji-area"><span>插入表情</span> <gdt-emojis @select="(e) => insertEmoji(e.label)"></gdt-emojis></div>
      <div class="input-rows" ref="inputsRef">
        <input
          class="line-input"
          @keypress.enter="onInputKeyPress(num)"
          @focus="onInputFocus(index)"
          v-for="(num, index) in lines"
          :key="num"
          placeholder="一行一个文案，最少2个字符，最多60个字符"
        />
      </div>
    </div>
    <p class="error-tips" v-if="errors.show">
      <span v-if="errors.line">第{{ errors.line }}行，</span>
      <span>{{ errors.msg }}</span>
    </p>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取消</el-button>
      <el-button @click="onConfirm" :loading="loading" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addTitlePackage, updateTitlePackage } from '@/api/common.model.js'
import { MEDIAS as MEDIA_LIST, MODAL_TYPE } from './consts/index.js'
import { MEDIAS } from '@/common/js/constants.js'
import { noop, getByteLen } from '@/common/js/utils'
import GdtEmojis from '@/components/gdt-emojis/index.vue'
const emojiRegExp = new RegExp(/\[(.*?)\]/, 'g')
export default {
  props: {
    value: {
      type: Boolean
    },

    defaultMedia: {
      type: Number,
      default: MEDIAS.TOUTIAO
    }
  },
  components: { GdtEmojis },
  data() {
    const validTitle = (rule, value, callback) => {
      if (!value) {
        callback(new Error('文案包名称不能为空'))
      }
      const len = getByteLen(value)
      if (len < 1 || len > 30) {
        callback(new Error('文案包名称在1-30个字符之间'))
      }
      callback()
    }
    return {
      modalType: MODAL_TYPE.ADD,
      loading: false,
      formItem: { packName: '', mediaIds: [this.defaultMedia] }, // mediaIds 默认选中uc
      errors: {
        line: 0,
        msg: '',
        show: false
      },
      rules: {
        packName: [{ validator: validTitle, trigger: 'blur' }]
      },
      lines: Array(20)
        .fill(1)
        .map((_, i) => i + 1),
      activeInputIndex: -1
    }
  },
  computed: {
    modalTitle() {
      return ['', '新增', '编辑'][this.modalType]
    },
    medias() {
      return MEDIA_LIST
    },
    showEmoji() {
      const { mediaIds } = this.formItem
      return mediaIds.includes(MEDIAS.GDT) && mediaIds.length === 1
    },
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    insertEmoji(text) {
      if (this.activeInputIndex < 0) return this.$Message.error('请先选择文案行')
      const activeInput = this.$refs.inputsRef.children[this.activeInputIndex]
      if (activeInput) {
        activeInput.setRangeText(text, activeInput.selectionStart, activeInput.selectionEnd, 'end')
        activeInput.focus()
      }
    },
    /**
     * @description: 编辑文案
     * @return {*}
     */
    setContent(row) {
      // 回显参数、并设置需要更新row的id
      this.formItem = Object.assign({}, this.formItem.packName, {
        packName: row.packName,
        mediaIds: row.mediaIds.split(',').map((id) => Number(id)),
        id: row.id
      })
      this.modalType = MODAL_TYPE.UPDATE
      this.$nextTick(() => {
        const inputs = this.$refs.inputsRef.children
        row.content.forEach((text, index) => {
          inputs[index].value = text
        })
      })
    },
    /**
     * @description: 回车模拟换行
     * @param {*} idx
     * @return {*}
     */
    onInputKeyPress(idx) {
      if (idx < 10) this.$refs.inputsRef.children[idx].focus()
    },
    onInputFocus(activeInputIndex) {
      this.activeInputIndex = activeInputIndex
    },

    getInputContents() {
      let content = []
      const inputs = this.$refs.inputsRef
      if (inputs && inputs.children.length) {
        content = Array.from(inputs.children)
          .map((i) => i.value)
          .filter((i) => !!i.trim())
      }

      return content
    },

    /**
     * @description: 提交
     * @return {*}
     */
    onConfirm() {
      const content = this.getInputContents()
      this.$refs.titleForm.validate((valid) => {
        if (valid && this.validateRows(content)) {
          // 媒体id逗号分割
          const mediaIds = this.formItem.mediaIds.join(',')
          this.loading = true
          const params = {
            ...this.formItem,
            mediaIds,
            content: content
          }

          ;[noop, addTitlePackage, updateTitlePackage][this.modalType](params).then((data) => {
            this.loading = false
            this.$Message.success(`${this.modalTitle}成功`)
            this.$emit('added')
            this.closeModal()
          })
        }
      })
    },
    /**
     * @description: 文案长度验证
     * @param {*} content
     * @return {*}
     */
    validateRows(content) {
      this.errors.show = false

      for (let i = 0; i < content.length; i++) {
        const textRow = content[i]
        const matchedItems = textRow.match(emojiRegExp) || []
        if (matchedItems.length > 4) {
          this.errors = {
            show: true,
            line: i + 1,
            msg: '最多只能添加4个表情'
          }
        }
      }

      // 找到不符合规则的条目index
      const invalidRowIndex = content.findIndex((row) => {
        const len = getByteLen(row)
        return len < 2 || len > 60
      })
      if (invalidRowIndex > -1) {
        const len = getByteLen(content[invalidRowIndex])
        this.errors = {
          show: true,
          line: invalidRowIndex + 1,
          msg: `不能少于2个字符或多于60个字符，当前${len}个字符`
        }
      } else if (!content.length) {
        this.errors = {
          show: true,
          line: 0,
          msg: '请至少输入一行文案'
        }
      }
      return !this.errors.show
    },
    closeModal() {
      // 清除表单校验
      this.$refs.titleForm.resetFields()
      // 清除文案校验信息
      this.errors.show = false
      // 清空每行的文案
      const inputs = this.$refs.inputsRef
      Array.from(inputs.children || []).forEach((i) => {
        i.value = ''
      })
      this.modalType = MODAL_TYPE.ADD
      // 关闭弹窗
      this.visible = false
    },
    handleMediaChange(vals) {
      const content = this.getInputContents()
      const matchedItems = content.map((row) => row.match(emojiRegExp)).filter((i) => i)
      const [mediaId] = vals

      if (mediaId === MEDIAS.GDT && vals.length === 1) {
      } else {
        if (matchedItems.length) {
          this.$confirm('请注意只有腾讯能选择表情符号，其他媒体需要清除', '提示', {
            confirmButtonText: '清除',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const inputs = this.$refs.inputsRef.children
            const content = Array.from(inputs).map((i) => i.value)
            content.forEach((text, index) => {
              inputs[index].value = text.replace(emojiRegExp, '')
            })
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .textarea-wrapper {
  border: 1px solid #dcdee2;
  border-radius: 4px;
  display: flex;
  padding: 4px 7px;
  position: relative;
  .emoji-area {
    display: flex;
    font-size: 13px;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }
  .mark-rows {
    text-align: right;
    margin-right: 8px;
    font-size: 12px;
    line-height: 20px;
    color: #999;
    white-space: nowrap;
  }
  .input-rows {
    width: 100%;

    input {
      display: block;
      width: 100%;
      height: 20px;
      line-height: 20px;
    }
  }
  .el-input__inner {
    border: none;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    &:focus {
      box-shadow: none;
    }
  }
}
.error-tips {
  line-height: 1;
  padding-top: 6px;
  color: #ed4014;
  font-size: 12px;
}
.dialog-footer {
  text-align: right;
}
</style>
